<template>
  <div>
    <Form ref="dataForm" :model="dataForm">
      <Row v-if="modalType == 'AddAudit' && canAddAuditSeq">
        <Col span="24">
          <FormItem label="加签方式:" prop="addAuditSeq">
            <Select v-model="dataForm.addAuditSeq" placeholder="请选择">
              <Option v-for="item in config.auditOrderMap" :value="item.value" :key="item.value">{{ item.name }}</Option>
            </Select>
          </FormItem>
        </Col>
      </Row>
      <Row>
        <Col span="24">
          <FormItem :label="modalType == 'AddAudit' ? '加签审批人:' : '转交人:'">
              <CopyerSetting ref="CopyerSetting" :dataConfig.sync="dataConfig" typeTitle="抄送人" :assignType="true" :multiple="multiple" />
          </FormItem>
        </Col>
      </Row>
      <Row>
        <Col span="24">
          <FormItem :label="modalType == 'AddAudit' ? '加签原因:' : '转交原因:'">
            <Input v-model.trim="dataForm.auditNote" type="textarea" :rows="4" :maxlength="300"></Input>
          </FormItem>
        </Col>
      </Row>
    </Form>
  </div>
</template>

<script>
import { config } from './config';
import CopyerSetting from '../../copyerSetting/coperSetting.vue'; // 抄送人
export default {
  components: { CopyerSetting },
  data() {
    return {
      config,
      dataConfig: {
        userType: 1
      },
      dataForm: {
        addAuditSeq: this.canAddAuditSeq ? 1 : 0, // 如果有顺序默认为1 否则为0
        auditNote: ''
      }
    };
  },
  props: {
    canAddAuditSeq: Boolean, // 加签是否有顺序
    modalType: String, // 类型 AddAudit加签   TransferAudit转交
    multiple: Boolean // 抄送人是否可以多选
  }
};
</script>

<style>

</style>
